var message = {
    empty: 'Input empty',
    name: 'Enter name',
    company: 'Enter company',
    email: 'Enter email',
    phone: 'Enter telephone'
}

/**
* Main validation form
* @param {form} jquery obj - Form
* @param {options} obj - object width params
*/
function validate(form, options){
    var setings = {
        errorFunction:null,
        submitFunction:null,
        highlightFunction:null,
        unhighlightFunction:null
    }
    $.extend(setings, options);

    var $form = $(form);

    if ($form.length && $form.attr('novalidate') === undefined) {
        $form.on('submit', function(e) {
            e.preventDefault();
        });

        $form.validate({
            errorClass : 'errorText',
            focusCleanup : false,
            onclick: true,
            onfocusout: true,
            onkeyup: true,
            focusInvalid : true,
            invalidHandler: function(event, validator) {
                if(typeof(setings.errorFunction) === 'function'){
                    setings.errorFunction(form);
                }
            },
            errorPlacement: function(error, element) {
                error.appendTo( element.closest('.form__input'));
            },
            highlight: function(element, errorClass, validClass) {
                $(element).addClass('error');
                $(element).closest('.form__row').addClass('error').removeClass('valid');
                if( typeof(setings.highlightFunction) === 'function' ) {
                    setings.highlightFunction(form);
                }
            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).removeClass('error');
                if($(element).closest('.form__row').is('.error')){
                    $(element).closest('.form__row').removeClass('error').addClass('valid');
                }
                if( typeof(setings.unhighlightFunction) === 'function' ) {
                    setings.unhighlightFunction(form);
                }
            },
            submitHandler: function(form) {
                if( typeof(setings.submitFunction) === 'function' ) {
                    setings.submitFunction(form);
                } else {
                    $form[0].submit();
                }
            }
        });

        $.validator.addMethod(
            "regex",
            function(value, element, regexp) {
                var check = false;
                var re = new RegExp(regexp);
                return this.optional(element) || re.test(value);
            }
      );
  
        //   $('[required]',$form).each(function(){
        //       $(this).rules( "add", {
        //           required: true,
        //           messages: {
        //               required: message.empty
        //           }
        //       });
        //   });
        //   if ($('.name-input[required]', $form).length) {
        //       $('.name-input[required]', $form).rules("add", {
        //           messages: {
        //               required: message.name
        //           }
        //       });
        //   }
  
        //   if ($('.company-input[required]', $form).length) {
        //       $('.company-input[required]', $form).rules("add", {
        //           messages: {
        //               required: message.company
        //           }
        //       });
        //   }
          
  
        //   if ($('.email-input[required]', $form).length) {
        //       $('.email-input[required]', $form).rules("add", {
        //           regex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        //           messages: {
        //               regex: message.email,
        //               required: message.email
        //           }
        //       });
        //   }
  
          if ($('.tel-input[required]', $form).length) {
              $('.tel-input[required]', $form).rules("add", {
                  minlength: 6,
                  maxlength: 15,
                  regex: /^[0-9]+$/,
                  messages: {
                    regex: 'Only numbers',
                    minlength: 'Minimum 6 numbers',
                    maxlength: 'Maximum 15 numbers'
                    }
              });
          }
    }
}


/**
* Sending form with a call popup
* @param {form} string - Form
*/
function validationCall(form){
  var thisForm = $(form);
  var formSur = thisForm.serialize();

    $.ajax({
        url : thisForm.attr('action'),
        data: formSur,
        method:'POST',
        success : function(data){
            thisForm.trigger("reset");
            $('.form__success').fadeIn(0)
            thisForm.trigger('reset');
            thisForm.find('.form__row label').fadeIn(0);
            thisForm.find('.form__row').removeClass('focus');
        }
    });

}


/**
* Sending form with a call popup
* @param {popupId} string - Id form, that we show
* @param {popupWrap} string - Name of class, for wrapping popup width form
*/
function popNext(popupId, popupWrap){

     $.fancybox.open({
        src  : popupId,
        type : '',
        opts : {
            baseClass: popupWrap || '',
            afterClose: function () {
                $('form').trigger("reset");
                clearTimeout(timer);
            }
        }
    });

    var timer = null;

    timer = setTimeout(function () {
        $('form').trigger("reset");
        $.fancybox.close();
    }, 2000);

}


/**
* Submitting the form with the file
* @param {form} string - Form
* не использовать input[type="file"] в форме и не забыть дописать форме enctype="multipart/form-data"
*/
function validationCallDocument(form){

    var thisForm = $(form);
    var formData = new FormData($(form)[0]);

    formData.append('file', thisForm.find('input[type=file]')[0].files[0]);

    $.ajax({
        url: thisForm.attr('action'),
        type: "POST",
        data: formData,
        contentType:false,
        processData:false,
        cache:false,
        success: function(response) {
            thisForm.trigger("reset");
           
        }
    });

}


/**
* Submitting the form with the files
* @param {form} string - Form
* не использовать input[type="file"] в форме и не забыть дописать форме enctype="multipart/form-data"
*/
function validationCallDocuments(form){

    var thisForm = $(form);
    var formData = new FormData($(form)[0]);

    $.each(thisForm.find('input[type="file"]')[0].files, function(index, file){
        formData.append('file['+index+']', file);
    });

    $.ajax({
        url: thisForm.attr('action'),
        type: "POST",
        data: formData,
        contentType:false,
        processData:false,
        cache:false,
        success: function(response) {
            thisForm.trigger("reset");
            popNext("#call_success", "call-popup");
        }
    });

}

function fileValidation(){
    var fileTypes = ['/pdf','/odt','/doc','/docx'];

    $('.section__cv-btn input').change(function(){
        var thisInput = $(this)
        var file = thisInput.get(0).files[0];
        console.log(file.size)
        if(file.size <= 5000000){
            // let filePath = file.type.match('(.*)/');
            let fileTypeInput = file.type.match('/(.*)');
            $.each(fileTypes, function(index, fileType){
                if(fileTypeInput[0] == fileType){
                    $('.section__cv-error, .cv-btn__label').fadeOut(0);
                    $('.section__cv-success').fadeIn(0);
                    validationCallDocument('.section__cv-btn');
                    thisInput.val(''); 
                    return false;
                }
                else{
                    $('.section__cv-error').fadeIn(0);
                    return false;
                }
            })
        }
    })
}

$(document).ready(function(){
   validate('#form', {submitFunction:validationCall});
   validate('#formMob', {submitFunction:validationCall});
   fileValidation()
});
